var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.81579,
    stroke: "#FC5A5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6633 10.7L14.3354 8.68377C14.4715 8.27543 14.8536 8 15.2841 8H20.6841C21.1145 8 21.4966 8.27543 21.6328 8.68377L22.3048 10.7H26.984C27.5363 10.7 27.984 11.1477 27.984 11.7C27.984 12.2523 27.5363 12.7 26.984 12.7H26.127L25.3931 25.1762C25.2998 26.7619 23.9867 28 22.3983 28H13.5699C11.9815 28 10.6683 26.7619 10.5751 25.1762L9.84116 12.7H9C8.44772 12.7 8 12.2523 8 11.7C8 11.1477 8.44772 10.7 9 10.7H13.6633ZM15.7715 10.7H20.1966L19.9633 10H16.0048L15.7715 10.7ZM24.1235 12.7H11.8446L12.5716 25.0587C12.6027 25.5873 13.0404 26 13.5699 26H22.3983C22.9277 26 23.3654 25.5873 23.3965 25.0587L24.1235 12.7ZM19.686 15.2376C19.7205 14.6864 20.1952 14.2675 20.7464 14.3019C21.2977 14.3364 21.7166 14.8112 21.6821 15.3624L21.2321 22.5624C21.1977 23.1136 20.7229 23.5325 20.1717 23.4981C19.6205 23.4636 19.2016 22.9888 19.236 22.4376L19.686 15.2376ZM16.7321 22.4376C16.7666 22.9888 16.3477 23.4636 15.7964 23.4981C15.2452 23.5325 14.7705 23.1136 14.736 22.5624L14.286 15.3624C14.2516 14.8112 14.6705 14.3364 15.2217 14.3019C15.7729 14.2675 16.2477 14.6864 16.2821 15.2376L16.7321 22.4376Z",
    fill: "#FC5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.eef00fbca541c38653a4774bd42f8c67.svg";
export { ForwardRef as ReactComponent };